export default {
	loading: {
		partIsLoading: "Caricamento del pezzo in corso...",
		partIsSaving: "Salvataggio del pezzo in corso...",
		anchorFaceIsChanging: "Cambio del lato superiore in corso...",
		featureIsSetting: "Applicazione della funzione in corso...",
		whileMarkingFeaturesMessage: "Contrassegno delle funzioni in corso...",
		imageAlt: "Caricamento in corso...",
	},
	errors: {
		modelCannotBeShown: "Non è possibile visualizzare il modello. Contattate il nostro helpdesk.",
		saveFailedTitle: "Errore durante il salvataggio",
		changeCouldNotBeMade: "Non è stato possibile eseguire la modifica. Contattate il nostro helpdesk.",
		messageCouldNotBeConfirmed: "Non è stato possibile confermare il messaggio.",
		weldlineDefinitionError:
			"Errore nella definizione dei cordoni di saldatura. Contattate info@blexon.com",
		modificationFailedShortDescription:
			"Non è stato possibile completare la modifica richiesta del modello. " +
			"Inviate l'articolo al nostro helpdesk per una verifica gratuita.",
		featureCreationFailedTitle: "Non è stato possibile creare la funzione",
		editingErrorTitle: "Errore durante la modifica",
		modelEditingFailedTitle: "Errore durante la modifica del modello",
		rollDirectionAdjustFailedTitle: "Non è stato possibile regolare la direzione di laminazione",
		rollDirectionAngleAdjustFailedTitle:
			"Non è stato possibile regolare l'angolo della direzione di laminazione",
		rollDirectionSetFailed:
			"Non è stato possibile impostare la direzione di laminazione. Utilizzate una linea su un " +
			"contorno esterno o un ritaglio.",
	},
	devMode: "DEV-MODE",
	panels: {
		editor: "Editor",
		mode: "Modalità",
		article: "Articolo",
		messages: "Messaggi",
		features: "Features",
		structure: "Struttura",
	},
	processType: {
		cut: "Taglio",
		cylindicBend: "Piegatura",
		engrave: "Incisione",
		formCountersink: "Svasatura",
		formExtrudedThread: "Filettatura estrusa",
		formScrewThread: "Formatura filettatura",
		weld: "Saldatura",
		drillCylinderHeadBoltHole: "Svasatura per vite a testa cilindrica",
		pressJoin: "Inserto pressato",
		none: "Nessun processo",
		unknown: "Processo sconosciuto",
	},
	editorMode: {
		featureMode: "Modifica",
		measuringMode: "Misurazione",
		rollDirectionMode: "Direzione di laminazione",
		weldMode: "Saldatura",
		none: "Nessuna modalità",
	},
	featureType: {
		undefined: "Non definito",
		anchorFace: "Lato superiore",
		bottomFace: "Lato inferiore",
		sideFace: "Lato esterno",
		bend: "Linea di piegatura",
		hole: "Foro rotondo",
		cutout: "Ritaglio",
		screwThread: "Filettatura",
		countersink: "Svasatura",
		extrudedThread: "Collare estruso",
		engraving: "Incisione",
		invalid: "Non valido",
		weldline: "Cordone di saldatura",
		cylinderHeadBoltHole: "Cordone di saldatura",
		pressJoin: "Inserto pressato",
		unknown: "Funzione sconosciuta",
	},
};
